import { View } from 'react-native';

import { Anchor } from '@fhs/ui';

interface Props {
  sections: {
    id: string;
    title: string;
    onPress: () => void;
    isActive: boolean;
    badge?: number;
  }[];
}

export function SectionsHeader({ sections }: Props) {
  return (
    <View style={{ flexDirection: 'row' }}>
      {sections.map(section => (
        <Anchor
          key={section.id}
          isActive={section.isActive}
          title={section.title}
          badge={section.badge}
          onPress={section.onPress}
          style={{ flex: 1, alignItems: 'center' }}
          titleStyle={{ textAlign: 'center', flex: 1 }}
          focusedStyle={{}}
          hoveredStyle={{}}
        />
      ))}
    </View>
  );
}
